export const reportDWHBuilder = (mode, params) => {
  let report;
  switch (mode) {
    case 'SHOWPAGE':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Enter Details Page',
        status: 'Ongoing',
        messageText: 'Details Page Displayed',
        param10: params?.param10,
      };
      break;
    case 'SEARCH_CLICK':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Enter Details Page',
        status: 'Ongoing',
        messageText: 'Details Page Search Button Clicked',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
      };
      break;
    case 'EMAIL_INPUT_SHOW':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Enter Details Page',
        status: 'Ongoing',
        messageText: 'Details Page Email Entry Displayed',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
      };
      break;
    case 'SEND_BUTTON':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Enter Details Page',
        status: 'Ongoing',
        messageText: 'Details Page Email Entry Button Clicked',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
      };
      break;
    case 'NO_QR_CODE':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Enter Details Page',
        status: 'Error',
        messageText: 'Details Page Error Text Displayed',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
      };
      break;
    case 'SUCCESS':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Success Screen Qr Code eSIM',
        status: 'Completed',
        messageText: 'Success Screen Qr Code eSIM',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
        businessDetails: params?.businessDetails,
      };
      break;
    case 'GENERAL_ERROR':
      report = {
        subArea: 'SendQrCodeeSIM',
        actionType: 'Error Screen',
        status: 'Error',
        messageText: 'Error Screen',
        param10: params?.param10,
        param1: params?.param1,
        param2: params?.param2,
      };
      break;
  }
  return report;
};
